import React, { useState } from "react";

import { getMediumServiceDetails } from "../../../../services/client";
import Prepaypostpaycheck from "./practitioners/subcomponents/prepaypostpaycheck";

/**
 * Book Now on a medium card: fetch what the medium offers, then open the
 * duration / payment popup (#Prepaypostpaycheck).
 *
 *   Book Now -> getMediumServiceDetails(medium_id)
 *            -> #Prepaypostpaycheck, where the client picks a duration
 *            -> onContinue(medium + subsession_id + payStatus)
 *
 * What happens after Continue differs by screen, so the caller supplies it. The
 * Professional Sessions listing already lives inside the booking pages and just
 * switches renderType; the favourites page is a separate page and hands off to
 * the booking pages instead.
 *
 * `bookingModal` is an element, not a component. A component defined inside the
 * hook would be a new type on every render and would remount the Bootstrap modal
 * mid-interaction.
 */
export default function useProfessionalBooking({ onContinue, getSubsessions }) {
  const [professionalInfo, setProfessionalInfo] = useState();
  const [mediumSessionInfo, setMediumSessionInfo] = useState();

  const getBookingLink = (info) => {
    setProfessionalInfo(info);

    if (info.show_flexbooker) {
      onContinue(info);
      return;
    }

    getMediumServiceDetails(info.medium_id)
      .then((data) => {
        if (data.data.status) {
          setMediumSessionInfo(data.data.data[0]);
          window.loadModal2("#Prepaypostpaycheck", "show");
        }
      })
      .catch(() => {});
  };

  const bookingModal = (
    <Prepaypostpaycheck
      mediumSessionInfo={mediumSessionInfo}
      getSubsessions={getSubsessions}
      paytypeText={""}
      startSeesion={onContinue}
      professionalInfo={professionalInfo}
    />
  );

  return {
    getBookingLink,
    professionalInfo,
    setProfessionalInfo,
    mediumSessionInfo,
    setMediumSessionInfo,
    bookingModal,
  };
}
